export default __webpack_public_path__ + "static/media/boiled-rice.c6bda731.jpg";